import { useConfigEditor, SaveBar, Field, TextArea, ImageInput, Section } from "../../lib/admin-shared";

const ListField = ({ label, value, onChange, testid }) => (
    <label className="block">
        <span className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-2 block">{label} (one per line)</span>
        <textarea rows={6} value={(value || []).join("\n")}
            onChange={(e) => onChange(e.target.value.split("\n").map((s) => s.trim()).filter(Boolean))}
            data-testid={testid}
            className="w-full px-4 py-3 rounded-sm border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary/40 resize-y font-mono text-sm" />
    </label>
);

export default function PagesEditor() {
    const { cfg, set, save, saving, saved, loading } = useConfigEditor();
    if (loading || !cfg) return <div className="text-muted-foreground">Loading…</div>;

    return (
        <div className="max-w-3xl space-y-8" data-testid="pages-editor">
            <div>
                <h1 className="font-display text-4xl mb-2">Static pages</h1>
                <p className="text-muted-foreground">Content shown on public /about and /programs pages. (Homepage content is managed under the Homepage section.)</p>
            </div>

            <Section title="Programs page (/programs)" description="The intro shown above the thematic area grid.">
                <Field label="Kicker (small uppercase label)" value={cfg.programs_page_kicker} onChange={(v) => set("programs_page_kicker", v)} testid="pg-programs-kicker" />
                <Field label="Page title" value={cfg.programs_page_title} onChange={(v) => set("programs_page_title", v)} testid="pg-programs-title" />
                <TextArea label="Introduction paragraph" value={cfg.programs_page_intro} onChange={(v) => set("programs_page_intro", v)} rows={4} testid="pg-programs-intro" />
            </Section>

            <Section title="Homepage — Programs section" description="The 'What We Do' section on the homepage.">
                <Field label="Kicker" value={cfg.home_programs_kicker} onChange={(v) => set("home_programs_kicker", v)} testid="pg-home-programs-kicker" />
                <Field label="Section title" value={cfg.home_programs_title} onChange={(v) => set("home_programs_title", v)} testid="pg-home-programs-title" />
                <Field label="'View all' link label" value={cfg.home_programs_view_all_label} onChange={(v) => set("home_programs_view_all_label", v)} testid="pg-home-programs-viewall" />
            </Section>

            <Section title="About page (/about)">
                <div>
                    <span className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-2 block">Hero image</span>
                    <ImageInput value={cfg.about_hero_image} onChange={(v) => set("about_hero_image", v)} testid="ab-hero-image" />
                </div>
                <TextArea label="Introduction" value={cfg.about_intro} onChange={(v) => set("about_intro", v)} rows={4} testid="ab-intro" />
                <TextArea label="Vision" value={cfg.about_vision} onChange={(v) => set("about_vision", v)} testid="ab-vision" />
                <TextArea label="Mission" value={cfg.about_mission} onChange={(v) => set("about_mission", v)} testid="ab-mission" />
                <ListField label="Core values" value={cfg.about_values} onChange={(v) => set("about_values", v)} testid="ab-values" />
                <ListField label="Strategic objectives" value={cfg.about_objectives} onChange={(v) => set("about_objectives", v)} testid="ab-objectives" />
                <TextArea label="Why YACRRD exists" value={cfg.about_why_exists} onChange={(v) => set("about_why_exists", v)} testid="ab-why" />
                <TextArea label="Areas of operation" value={cfg.about_areas_operation} onChange={(v) => set("about_areas_operation", v)} testid="ab-areas" />
            </Section>

            <SaveBar onSave={save} saving={saving} saved={saved} />
        </div>
    );
}

export { Field as _F };
